/**
 * The authentication gate in front of every route except `/signin`.
 *
 * This is navigation, not security. The server re-checks the session and the row
 * scope on every request; redirecting an unauthenticated user here simply saves them
 * from watching a shell full of 401s. The route they wanted is carried in location
 * state so sign-in can put them back where they were headed.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "@/components/ui";
import { useSession } from "@/lib/session";

export function RequireAuth() {
  const { me, ready } = useSession();
  const location = useLocation();

  // `/me` has not answered yet — showing the shell would flash a signed-out state.
  if (!ready) {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
        <Spinner size={22} label="Loading BotpressoHR" />
      </div>
    );
  }

  if (!me) {
    return (
      <Navigate
        to="/signin"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <Outlet />;
}

export default RequireAuth;
